export const routerConstants = {
  home: '/',
  signIn: '/sign-in',
  resetPassword: '/reset-password',
  clientApi: '/clients-api',
};
